import styled from 'styled-components';

export const DarkBackground = styled.div`
  justify-content: center;
  align-items: center;
`;